import "core-js/modules/es.array.unscopables.flat-map.js";

function t(...r) {
  return Array.from(new Set(r.flatMap(n => typeof n == "string" ? n.split(" ") : []))).filter(Boolean).join(" ");
}

export { t as classNames };